<template>
  <el-dialog
    center
    title="Impressão"
    :show-close="false"
    :fullscreen="true"
    :visible="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <el-tabs type="card" v-model="activeTab" tabindex="-1">
      <el-tab-pane
        name="tag"
        tabindex="-1"
        label="Etiquetas"
        :disabled="!prepost"
      >
        <iframe :src="`${prepost}#toolbar=0`" class="pdv-print__frame">
          Oops! an error has occurred.
        </iframe>
      </el-tab-pane>
      <el-tab-pane
        name="proof"
        tabindex="-1"
        label="Comprovante"
        :disabled="!proof"
      >
        <iframe :src="proof" class="pdv-print__frame">
          Oops! an error has occurred.
        </iframe>
      </el-tab-pane>
      <el-tab-pane
        v-if="external"
        name="external"
        tabindex="-1"
        label="Terceiros"
      >
        <iframe :src="external" class="pdv-print__frame">
          Oops! an error has occurred.
        </iframe>
      </el-tab-pane>
      <el-tab-pane
        v-if="motoboy"
        name="motoboy"
        tabindex="-1"
        label="Motoboy"
      >
        <iframe :src="motoboy" class="pdv-print__frame">
          Oops! an error has occurred.
        </iframe>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer pdv-print__footer">
      <span v-if="stepHint" class="pdv-print__step">{{ stepHint }}</span>
      <el-button
        type="primary"
        :icon="buttonIcon"
        :loading="printing"
        @click.stop.prevent="handlePrint"
        >{{ buttonLabel }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "PdvPrintDialog",
  props: {
    visible: { type: Boolean, default: false },
    proof: { type: String, default: null },
    prepost: { type: String, default: null },
    external: { type: String, default: null },
    motoboy: { type: String, default: null },
    initialTab: { type: String, default: "tag" },
  },
  data() {
    return {
      activeTab: this.initialTab,
      printed: { tag: false, proof: false },
      printing: false,
    };
  },
  computed: {
    nextDoc() {
      if (this.prepost && !this.printed.tag) return "tag";
      if (this.proof && !this.printed.proof) return "proof";
      return null;
    },
    buttonLabel() {
      if (this.nextDoc === "tag") return "Imprimir etiquetas";
      if (this.nextDoc === "proof") return "Imprimir comprovante";
      return "Concluir";
    },
    buttonIcon() {
      return this.nextDoc ? "el-icon-printer" : "el-icon-check";
    },
    stepHint() {
      const totalSteps = (this.prepost ? 1 : 0) + (this.proof ? 1 : 0);
      if (totalSteps < 2 || !this.nextDoc) return "";
      const currentStep = this.nextDoc === "tag" ? 1 : 2;
      return `Impressão ${currentStep} de ${totalSteps}`;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.printed = { tag: false, proof: false };
        this.printing = false;
        this.activeTab = this.resolveInitialTab();
      }
    },
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    resolveInitialTab() {
      const map = {
        tag: this.prepost,
        proof: this.proof,
        external: this.external,
        motoboy: this.motoboy,
      };
      if (map[this.initialTab]) return this.initialTab;
      return Object.keys(map).find((k) => map[k]) || "tag";
    },
    handlePrint() {
      const doc = this.nextDoc;
      if (!doc) {
        this.close();
        return;
      }
      const src = doc === "tag" ? this.prepost : this.proof;
      this.printSrc(src, () => {
        this.printed[doc] = true;
        const next = this.nextDoc;
        if (next) {
          this.activeTab = next;
        } else {
          this.close();
        }
      });
    },
    printSrc(src, done) {
      const vm = this;
      let printUrl = src;
      if (src.indexOf("data:application/pdf;base64,") === 0) {
        const byteCharacters = atob(
          src.replace("data:application/pdf;base64,", "")
        );
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        printUrl = URL.createObjectURL(blob);
      }
      vm.printing = true;
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = printUrl;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          vm.printing = false;
          done();
        }, 2000);
      };
    },
  },
};
</script>

<style>
.pdv-print__frame {
  width: 100%;
  height: calc(100vh - 230px);
  min-height: 400px;
  border: none;
}

.pdv-print__footer {
  display: inline-flex;
  align-items: center;
}

.pdv-print__step {
  font-size: 13px;
  color: #909399;
  margin-right: 14px;
  font-variant-numeric: tabular-nums;
}
</style>
